import React from "react";
import { ItemFile } from "../../../../store/viewmodels/ItemFileViewModel";
import { getFileElement } from "../../../../utils/TaskContentServices";

interface CombineCardProps {
    index: number,
    place: string,
    itemid: number,
    file?: ItemFile,
    setSelectedCards: React.Dispatch<React.SetStateAction<{ row: string, index: number }[]>>,
    selectedCards: { row: string, index: number }[],
    updated: boolean,
}

function CombineCard(props: CombineCardProps): JSX.Element {
    React.useEffect(() => {
        setSelected(false);
    }, [props.updated]);

    const [selected, setSelected] = React.useState(false);
    let fileElement = props.file !== undefined ? getFileElement(props.file) : <div className="hidden text-teal-500 text-md xl:text-xl 3xl:text-2xl 5xl:text-3xl 7xl:text-4xl">Siirrä kortti tähän</div>;
    let elementButton: JSX.Element = <></>

    const onCardClick = () => {
        if (selected) {
            setSelected(!selected);
        }
        else {
            let selCards = Array.from(props.selectedCards);
            selCards.push({ row: props.place, index: props.index })
            props.setSelectedCards(selCards)
            setSelected(!selected);
        }
    }

    if (props.place === "firstRow") {
        elementButton = (
            <div className="w-full h-full p-1.5 md:p-2 lg:p-3 4xl:p-4" key={"combinecard cursor-not-allowed" + props.place + props.index}>
                <div key={"combinecardButton" + props.place + props.index} className={"flex w-full h-full mx-auto bg-gray-200 overflow-hidden rounded-lg ring-4 lg:ring-8 ring-gray-200 cursor-not-allowed"}>
                    {fileElement}
                </div>
            </div>
        );
    } else {
        let placeColor = props.place === "secondRow" ? " ring-yellow-500 text-yellow-500 hover:text-yellow-300 " : " ring-teal-500 text-teal-500 hover:text-teal-300 ";
        let selectedColor = selected ? " ring-amber-300 text-amber-300 " : placeColor;

        let symbol = props.place === "secondRow" ? "ri-arrow-down-circle-fill" : "ri-arrow-up-circle-fill";
        let symbolSize = " absolute text-3xl lg:text-5xl 2xl:text-6xl 6xl:text-8xl 10xl:text-9xl "

        elementButton = (
            <div className="relative w-full h-full p-1.5 md:p-2 lg:p-3 4xl:p-4" key={"combinecard" + props.place + props.index} onClick={onCardClick}>
                <div key={"combinecardButton" + props.place + props.index} className={"flex w-full h-full mx-auto overflow-hidden rounded-lg ring-4 lg:ring-8 bg-white " + selectedColor}
                    onClick={onCardClick}>
                    {fileElement}
                </div>

                <div key={""} className={"z-50 absolute -top-2 -left-1 lg:-top-2 lg:-left-2 xl:-top-3 xl:-left-3 2xl:-top-4 2xl:-left-4 5xl:-top-3 5xl:-left-3 6xl:-top-4 6xl:-left-4 8xl:-left-6 8xl:-top-7"} onClick={onCardClick}>
                    <div className="relative">
                        <span className={" text-white ri-checkbox-blank-circle-fill " + symbolSize}></span>
                        <span className={selectedColor + symbolSize + symbol}></span>
                    </div>
                </div>
            </div>
        );
    }
    return elementButton;
}

export default CombineCard;